import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { makeStyles } from '@mui/styles';
import { storeKrunica } from '../store/KrunicaStore';

const useStyles = makeStyles((theme) => ({
  opisMolitve: {
    justifyContent: 'space-between',
    margin: ' auto',
    fontSize: '1.6rem',
    textAlign: 'center',
    lineHeight: '1.2',
    [theme.breakpoints.up('sm')]: {
      color: '#093145',
      fontSize: '2rem',
    },
  },
}));

function OmojIsuse() {
  const classes = useStyles();
  const { aktivnaZemlja } = storeKrunica;

  return (
    <Fragment>
      <div className={classes.opisMolitve}>{aktivnaZemlja.oMojIsuse}</div>
    </Fragment>
  );
}

export default observer(OmojIsuse);
